/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PlaqueEtrangerDto } from '../models/plaque-etranger-dto';


/**
 * Fonctions de gestion des plaques d'un étranger
 */
@Injectable({
  providedIn: 'root',
})
export class PlaquesEtrangerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation plaquesEtrangerGetList
   */
  static readonly PlaquesEtrangerGetListPath = '/api/plaques-etranger/list/{etrangerId}';

  /**
   * Renvoie la liste des plaques de l'étranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesEtrangerGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesEtrangerGetList$Response(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;
  }): Observable<StrictHttpResponse<Array<PlaqueEtrangerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesEtrangerService.PlaquesEtrangerGetListPath, 'get');
    if (params) {
      rb.path('etrangerId', params.etrangerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlaqueEtrangerDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de l'étranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesEtrangerGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesEtrangerGetList(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;
  }): Observable<Array<PlaqueEtrangerDto>> {

    return this.plaquesEtrangerGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PlaqueEtrangerDto>>) => r.body as Array<PlaqueEtrangerDto>)
    );
  }

  /**
   * Path part for operation plaquesEtrangerLoadList
   */
  static readonly PlaquesEtrangerLoadListPath = '/api/plaques-etranger/load-list/{etrangerId}';

  /**
   * Renvoie la liste des plaques de l'étranger spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesEtrangerLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesEtrangerLoadList$Response(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesEtrangerService.PlaquesEtrangerLoadListPath, 'post');
    if (params) {
      rb.path('etrangerId', params.etrangerId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de l'étranger spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesEtrangerLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesEtrangerLoadList(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.plaquesEtrangerLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation plaquesEtrangerGet
   */
  static readonly PlaquesEtrangerGetPath = '/api/plaques-etranger/{id}';

  /**
   * Renvoie la plaque spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesEtrangerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesEtrangerGet$Response(params: {

    /**
     * Identifiant de la plaque
     */
    id: number;
  }): Observable<StrictHttpResponse<PlaqueEtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesEtrangerService.PlaquesEtrangerGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaqueEtrangerDto>;
      })
    );
  }

  /**
   * Renvoie la plaque spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesEtrangerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesEtrangerGet(params: {

    /**
     * Identifiant de la plaque
     */
    id: number;
  }): Observable<PlaqueEtrangerDto> {

    return this.plaquesEtrangerGet$Response(params).pipe(
      map((r: StrictHttpResponse<PlaqueEtrangerDto>) => r.body as PlaqueEtrangerDto)
    );
  }

  /**
   * Path part for operation plaquesEtrangerPut
   */
  static readonly PlaquesEtrangerPutPath = '/api/plaques-etranger/{id}';

  /**
   * Met à jour la plaque spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesEtrangerPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesEtrangerPut$Response(params: {

    /**
     * Identifiant de la plaque à mettre à jour
     */
    id: number;

    /**
     * Plaque
     */
    body: PlaqueEtrangerDto
  }): Observable<StrictHttpResponse<PlaqueEtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesEtrangerService.PlaquesEtrangerPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaqueEtrangerDto>;
      })
    );
  }

  /**
   * Met à jour la plaque spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesEtrangerPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesEtrangerPut(params: {

    /**
     * Identifiant de la plaque à mettre à jour
     */
    id: number;

    /**
     * Plaque
     */
    body: PlaqueEtrangerDto
  }): Observable<PlaqueEtrangerDto> {

    return this.plaquesEtrangerPut$Response(params).pipe(
      map((r: StrictHttpResponse<PlaqueEtrangerDto>) => r.body as PlaqueEtrangerDto)
    );
  }

  /**
   * Path part for operation plaquesEtrangerDelete
   */
  static readonly PlaquesEtrangerDeletePath = '/api/plaques-etranger/{id}';

  /**
   * Supprime la plaque spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesEtrangerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesEtrangerDelete$Response(params: {

    /**
     * Identifiant de la plaque à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesEtrangerService.PlaquesEtrangerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la plaque spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesEtrangerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesEtrangerDelete(params: {

    /**
     * Identifiant de la plaque à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.plaquesEtrangerDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation plaquesEtrangerPost
   */
  static readonly PlaquesEtrangerPostPath = '/api/plaques-etranger/{etrangerId}';

  /**
   * Crée la plaque spécifiée pour un étranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesEtrangerPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesEtrangerPost$Response(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;

    /**
     * Plaque
     */
    body: PlaqueEtrangerDto
  }): Observable<StrictHttpResponse<PlaqueEtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesEtrangerService.PlaquesEtrangerPostPath, 'post');
    if (params) {
      rb.path('etrangerId', params.etrangerId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaqueEtrangerDto>;
      })
    );
  }

  /**
   * Crée la plaque spécifiée pour un étranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesEtrangerPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesEtrangerPost(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;

    /**
     * Plaque
     */
    body: PlaqueEtrangerDto
  }): Observable<PlaqueEtrangerDto> {

    return this.plaquesEtrangerPost$Response(params).pipe(
      map((r: StrictHttpResponse<PlaqueEtrangerDto>) => r.body as PlaqueEtrangerDto)
    );
  }

}
